import {
  CircularProgress,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import MDButton from "components/MDButton";
import React, { useCallback, useRef, useState } from "react";
import { useSelector } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch } from "react-redux";
import { IsheadingExistBlog, openSnackbar } from "../../redux/slices/common";
import { closeCustomModalDialog } from "../../redux/slices/modalSlice";
import { createStrain } from "../../redux/slices/strain";
import { strainPrompt } from 'prompt';
import { convertAndExtractMeta } from 'utilities/common';
import { singleStrainDetailPagePrompt } from 'prompt';
import { convertAndExtractStrainMeta } from 'utilities/common';
import { getData } from 'utilities/common';
import { STILO,HYPERWOLF } from 'utilities/constants';

export default function AddNewStrainModalHw({ closeModal }) {
  const { modalData, } = useSelector((state) => state.modal);
  const dispatch = useDispatch();
  const { fetchProductStrainsData = () => { } } = modalData;
  const { infoEffectData = [], } = useSelector((state) => state.common);
  const [errors, setError] = useState({});
  const [formData, setFormData] = useState({
    strainName: "",
    strainCategory: "",
    isReviewed: true,
    productId: modalData.productId
  });
  const [isPromptLoading, setPromptIsLoading] = useState(false)
  const adminsMode = getData('adminsMode')
  const isStilo = JSON.parse(adminsMode) === STILO
  const isHyperwolf = JSON.parse(adminsMode) === HYPERWOLF
  const debounceRef = useRef(null);

  const handlePostTitleChange = (value) => {
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    debounceRef.current = setTimeout(() => {
      dispatch(IsheadingExistBlog({ heading: value, strain: true }))
        .unwrap()
        .then(() => {
          setError({ strainName: "" });
        })
        .catch((err) => {
          setError({ strainName: err?.message || "An error occurred" });
        });
    }, 500); // 500ms delay
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "strainName") {
      handlePostTitleChange(value);
    }
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const showError = (message, errorType) => {
    if (errorType === "success") {
      dispatch(openSnackbar({ content: message, color: "success", icon: "check" }));
    }
    if (errorType === "error") {
      dispatch(openSnackbar({ content: message, color: "error", icon: "warning" }));
    }
  };
  const submitStrain = useCallback((payload) => {
    dispatch(createStrain(payload))
      .unwrap()
      .then((res) => {
        showError(res.message, "success");
        dispatch(closeCustomModalDialog());
        fetchProductStrainsData();
      })
      .catch((err) => {
        showError(err?.message, "error");
      });
  }, [dispatch, fetchProductStrainsData]);

  const handleGenerate = useCallback(async () => {
    const { strainName, strainCategory } = formData;
    setPromptIsLoading(true);
    setFormData(prev => ({
      ...prev,
      description: '',
      metaTitle: '',
      metaDescription: ''
    }));

    try {
      const prompt = strainPrompt(strainName);
      const res = await fetch(`${process.env.REACT_APP_STILO_API_BASE_URL}/api/v1/generate/description`, {
        method: "POST",
        body: JSON.stringify({ prompt }),
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_API_AUTH_KEY
        },
      });

      const reader = res.body.getReader();
      const decoder = new TextDecoder("utf-8");
      let fullContent = "";

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        fullContent += decoder.decode(value, { stream: true });
        const streamedResult = convertAndExtractMeta(fullContent);
        setFormData((prev) => ({
          ...prev,
          description: streamedResult.content,
          metaTitle: streamedResult.metaTitle || prev.metaTitle,
          metaDescription: streamedResult.metaDescription,
        }));
      }

      const finalResult = convertAndExtractMeta(fullContent);
      const payload = {
        strainName,
        strainCategory,
        productId: modalData.productId,
        isReviewed: true,
        description: finalResult.content,
        metaTitle: finalResult.metaTitle,
        metaDescription: finalResult.metaDescription,
        status:true
      };

      setFormData((prev) => ({ ...prev, ...payload }));
      setError({});
      submitStrain(payload);
    } catch (error) {
      showError(error?.message || "Failed to generate strain content", "error");
    } finally {
      setPromptIsLoading(false);
    }
  }, [formData, modalData.productId, submitStrain]);

  const handleGenerateHemp = useCallback(async () => {
    const { strainName, strainCategory } = formData;
    setPromptIsLoading(true);
    setFormData(prev => ({
      ...prev,
      description: '',
      metaTitle: '',
      metaDescription: '',
      title: '',
      title2: '',
      faq: []
    }));

    try {
      const prompt = singleStrainDetailPagePrompt({ strainName, platform: "hemp" });
      const res = await fetch(`${process.env.REACT_APP_STILO_API_BASE_URL}/api/v1/generate/description`, {
        method: "POST",
        body: JSON.stringify({ prompt }),
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_API_AUTH_KEY
        },
      });

      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }

      const reader = res.body.getReader();
      const decoder = new TextDecoder("utf-8");
      let fullContent = "";

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        fullContent += decoder.decode(value, { stream: true });
        const streamedResult = convertAndExtractStrainMeta(fullContent);
        setFormData((prev) => ({
          ...prev,
          description: streamedResult.longDescription,
          metaTitle: streamedResult.metaTitle || prev.metaTitle,
          metaDescription: streamedResult.metaDescription,
          title: streamedResult.title || prev.title,
          title2: streamedResult.title2 || prev.title2,
          faq: streamedResult.faq || [],
         
          image: {
            url: prev?.image?.url,
            alt: streamedResult?.altImage || prev?.image?.alt
          },
        }));
      }

      const finalResult = convertAndExtractStrainMeta(fullContent);
      const payload = {
        strainName,
        strainCategory,
        productId: modalData.productId,
        isReviewed: true,
        description: finalResult.longDescription,
        metaTitle: finalResult.metaTitle,
        metaDescription: finalResult.metaDescription,
        title: finalResult.title,
        title2: finalResult.title2,
        faq: finalResult.faq || [],
        status:true,
        ...(isHyperwolf ? {} : {
          image: {
            alt: finalResult?.altImage || '',
          },
        }),
   
      };

      setFormData((prev) => ({ ...prev, ...payload }));
      submitStrain(payload);
    } catch (error) {
      showError(error?.message || "Failed to generate strain content", "error");
    } finally {
      setPromptIsLoading(false);
    }
  }, [formData, modalData.productId, submitStrain]);
  const handleSave = () => {
    if (!formData.strainName) {
      setError({
        strainName: "Strain Name is required",
      });
      return;
    }
    if (!formData.strainCategory) {
      setError({
        strainCategory: "Strain Category is required",
      });
      return;
    }
    isStilo ? handleGenerate() : handleGenerateHemp();
  };

  return (
    <>
      <DialogTitle
        id="draggable-dialog-title"
        display="flex"
        alignItems="center"
        justifyContent="space-between"
      >
        Add New Strain
        <IconButton onClick={closeModal} edge="end" size="small">
          <CloseIcon fontSize="medium" />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Grid container alignItems="start" spacing={1} pt={1}>
            <Grid item xs={12} sm={12} md={6}>
              <TextField
                name="strainName"
                label="Strain Name"
                value={formData.strainName}
                onChange={handleInputChange}
                fullWidth
                error={Boolean(errors?.strainName)}
                helperText={errors?.strainName}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <FormControl fullWidth>
                <InputLabel>Strain Category*</InputLabel>
                {
                  isStilo ?  <Select
                  className="form-select"
                  error={Boolean(errors?.strainCategory)}
                  onChange={handleInputChange} label="Strain Type" name="strainCategory" value={formData.strainCategory}>
                  {[
                    { name: 'Indica', value: 'Indica' },
                    { name: 'Indica / Hybrid', value: 'Indica-dominant Hybrid' },
                    { name: 'Hybrid', value: 'Hybrid' },
                    { name: 'Sativa / Hybrid', value: 'Sativa-dominant Hybrid' },
                    { name: 'Sativa', value: 'Sativa' },
                  ].map((strain) => (
                    <MenuItem key={strain.value} value={strain.value}>{strain.name}</MenuItem>
                  ))}
                </Select>
                :
                <Select
                disabled={errors?.strainName}
                className="form-select"
                //   error={Boolean(errors?.strainCategory)}
                onChange={handleInputChange}
                label="Strain Category*"
                name="strainCategory"
                value={formData.strainCategory}

              >
                {infoEffectData?.map((infoStrain) => {
                  return (
                    <MenuItem key={infoStrain.strainType} value={infoStrain.strainType}>
                      {infoStrain?.strainType}
                    </MenuItem>
                  );
                })}
              </Select>

                }
         
                {Boolean(errors?.strainCategory) && <FormHelperText error>{errors?.strainCategory}</FormHelperText>}
              </FormControl>
            </Grid>
          </Grid>
        </DialogContentText>
      </DialogContent>
      <DialogActions className="footer-modal" sx={{ flexDirection: 'column', gap: 1, mb: 1.5 }}>
        <div style={{ display: 'flex', gap: 8 }}>
          <MDButton
            onClick={closeModal}
            sx={{ minWidth: "160px" }}
            type="button"
            variant="outlined"
            color="dark"
          >
            Cancel
          </MDButton>
          <MDButton
            onClick={handleSave}
            disabled={isPromptLoading || Boolean(errors?.strainName)}
            sx={{ minWidth: "160px" }}
            color="primary"
            type="button"
            variant="contained"
          >
            {isPromptLoading ? <CircularProgress size={20} color="inherit" /> : "Save"}
          </MDButton>
        </div>
        {isPromptLoading && (
          <Typography variant='caption' sx={{ color: 'text.secondary', fontSize: '0.75rem' }}>
            Wait a moment, generating content for this strain
          </Typography>
        )}
      </DialogActions>
    </>
  );
}
